import './CsvManagementModal.scss';
import { Modal, ModalBody, ModalHeader } from 'plume-ui';
import { ModalStyles } from 'plume-ui/dist/components/Modal/Modal';
import { FunctionComponent, memo } from 'react';
import { CsvFileSummary } from '../../types';
import CsvManagement from './CsvManagement';
import CsvTemplate from './CsvTemplate';

type CsvManagementModalProps = {
  title?: string;
  show: boolean;
  callback: (csvFile: CsvFileSummary) => void;
  onClose: () => void;
};

const CsvManagementModal: FunctionComponent<CsvManagementModalProps> = (
  props,
) => {
  return (
    <Modal
      fullWidth={true}
      isOpen={props.show}
      onRequestClose={props.onClose}
      classes={(current: ModalStyles) => ({
        ...current,
        root: `${current.root} CsvManagementModal`,
      })}
    >
      <ModalHeader title={props.title} subtitle={<CsvTemplate />} />
      <ModalBody>
        <CsvManagement
          callback={(csv: CsvFileSummary) => {
            props.callback(csv);
            props.onClose();
          }}
        />
      </ModalBody>
    </Modal>
  );
};

export default memo(CsvManagementModal);
